<template>
  <v-dialog v-model="splitScreenDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{tsg('selectSplitScreenLayout')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="splitScreenDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0" justify="center">
              <v-col class="ma-0 pa-0" cols="12">
					      <v-row class="ma-0 pa-0 pt-5 pb-9" align="center" justify="center">

					      	<v-col class="ma-0 pa-0" cols="4"
                         v-if="viewCount !== 4">
                    <v-row class="ma-0 pa-0" justify="center">
					      		  <v-img class="ma-0 pa-0 mb-4" id="split_image"
					      		  	src="@/assets/images/4view.png"></v-img>
                    </v-row>
                    <v-row class="ma-0 pa-0" justify="center">
					      		  <v-btn width="8rem" class="ma-0 pa-0 pl-2 pr-2" 
					      		  	id="blue_btn" elevation="0" @click="setViewCount(4)">
					      		  	{{'4' + tsg('createdLayoutWithCameras')}}
					      		  </v-btn>
                    </v-row>
					      	</v-col>

					      	<v-col class="ma-0 pa-0" cols="4"
                         v-if="viewCount !== 9">
					      		<v-row class="ma-0 pa-0" justify="center">
					      		  <v-img class="ma-0 pa-0 mb-4" id="split_image"
					      		  	src="@/assets/images/9view.png"></v-img>
                    </v-row>
                    <v-row class="ma-0 pa-0" justify="center">
					      		  <v-btn width="8rem" class="ma-0 pa-0 pl-2 pr-2" 
					      		  	id="blue_btn" elevation="0" @click="setViewCount(9)">
					      		  	{{'9' + tsg('createdLayoutWithCameras')}}
					      		  </v-btn>
                    </v-row>
					      	</v-col>

					      	<v-col class="ma-0 pa-0" cols="4"
                         v-if="viewCount !== 16">
					      	  <v-row class="ma-0 pa-0" justify="center">
					      		  <v-img class="ma-0 pa-0 mb-4" id="split_image"
					      		  	src="@/assets/images/16view.png"></v-img>
                    </v-row>
                    <v-row class="ma-0 pa-0" justify="center">
					      		  <v-btn width="8rem" class="ma-0 pa-0 pl-2 pr-2" 
					      		  	id="blue_btn" elevation="0" @click="setViewCount(16)">
					      		  	{{'16' + tsg('createdLayoutWithCameras')}}
					      		  </v-btn>
                    </v-row>
					      	</v-col>

					      </v-row>
				      </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean,
    viewCount: { type: Number, default: 16 }
  },
	components: {
		customDialog
	},
	mixins: [mixin.common],
  data: () => ({
    splitScreenDialogVisible: false,
  }),
  watch: {
    dialogVisible: function(item) {
      this.splitScreenDialogVisible = item;
    },
    splitScreenDialogVisible: function(item) {
      this.$emit('visible', item);
    }
  },
  created() {
  },
  methods: {
    tsg(t) {
      return this.$t("lang.group." + t);
    },
    setViewCount(value) {
			this.$emit('selectedViewCount', value);
      this.splitScreenDialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
#split_image {
  max-width: 8rem;
}
</style>